<template>
  <div class="chips-container">
    <v-chip
      v-for="preference in prefChipsData.data"
      :key="preference.name"
      class="chips"
      :style="{'background-color' : preference.match ? prefChipsData.color : colors.hwayzShadow}"
      disabled
      @click="$emit('pref-toggle', preference)"
    >
      {{ preference.name }}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    prefChipsData: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.pref-percent
  width: 8rem

.chips-container
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  margin-top: 1rem
  text-align: center
  &:after
    content: ''
    flex: auto
  @media only screen and (min-width: 960px)
    text-align: left

  h4
    margin-bottom: 1.5rem
    font-size: $hwayzFont1rem4

  .chips
    font-size: 1.1rem
    height: 2.4rem
    color: $hwayzWhite !important
</style>
